import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiCheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from "../FormControlLabel";
import classNames from "classnames";
import ErrorHandlingFormHelperText from "../ErrorHandlingFormHelperText";
import PopoverButton from "../PopoverButton";

/**
 * @deprecated Use CheckboxProps instead
 */

export const Checkbox = props => {
  const {
    id,
    className,
    checked,
    label,
    onChange,
    helperText,
    popoverText,
    ...otherProps
  } = props;
  const [checkedState, setCheckedState] = React.useState(Boolean(checked));
  React.useEffect(() => {
    setCheckedState(Boolean(checked));
  }, [checked]);
  const handleOnChange = e => {
    const checked = e.target.checked;
    setCheckedState(checked);
    onChange && onChange(e, checked);
  };
  const checkbox = /*#__PURE__*/React.createElement(MuiCheckbox, _extends({
    id: id,
    checked: checkedState,
    onChange: handleOnChange,
    className: classNames("prmbl-checkbox", className)
  }, otherProps));
  return label ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    id: id ? `${id}-label` : undefined,
    control: checkbox,
    label: label
  }), /*#__PURE__*/React.createElement(ErrorHandlingFormHelperText, {
    id: id,
    helperText: popoverText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopoverButton, {
      id: id,
      popoverText: popoverText
    }), helperText) : helperText
  })) : checkbox;
};
export default Checkbox;